module.exports = function() {
  return new Worker(__webpack_public_path__ + "d94c7901da41328ac945.worker.js");
};